import React from 'react';
import { Button } from 'react-bootstrap';
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { MdOutlineArrowForwardIos } from "react-icons/md";
import { MdKeyboardDoubleArrowLeft } from "react-icons/md";
import { MdOutlineArrowBackIos } from "react-icons/md";

//redux
import { useSelector, useDispatch } from 'react-redux';
import { selectCurrentPage, selectCurrentRange, selectPageCount, selectRowsPerPage, setCurrentPage } from '_redux/slices/timeline/timeline-control';
import { selectUsedTheme } from '_redux/slices/timeline/theme';

// style
import { Colors } from '_styles';

const PaginationV2 = () => {
    //#region redux
    const dispatch = useDispatch();

    const rowsPerPage = useSelector(selectRowsPerPage)
    const currentPage = useSelector(selectCurrentPage);          // employee pagination CurrentPage
    const pageCount = useSelector(selectPageCount);              // employee pagination PageCount
    const currentRange = useSelector(selectCurrentRange);        // employee pagination currentRange
    const usedTheme = useSelector(selectUsedTheme);
    //#endregion

    //#region functions
    // reset the employee pagination page to the first page 
    const moveToStart = () => {
        dispatch(setCurrentPage(1));
    };

    // move to the Previous page in employee pagination
    const handlePrevPage = () => {
        if (currentPage > 1) {
            dispatch(setCurrentPage(currentPage - 1));
        }
    };

    // move to the next page in employee pagination
    const handleNextPage = () => {
        if (currentPage < pageCount) {
            dispatch(setCurrentPage(currentPage + 1));
        }
    };

    // reset the employee pagination page to the  page 
    const moveToEnd = () => {
        dispatch(setCurrentPage(pageCount));

    };

    return (
        <div style={{ display: "flex", alignItems: "center", marginInline: "5px" }}>
            <div style={{ height: "fit-content", gap: "5px", display: "flex" }}>

                {/* Previous page Btn */}
                <Button
                    onClick={handlePrevPage}
                    disabled={currentPage === 1}

                    style={{ padding: 0, width: "23px", height: "23px", alignItems: "center", display: "flex", justifyContent: "center", backgroundColor: usedTheme.BACKGROUND_COLOR, color: usedTheme.JOB_LIST_COLOR, borderColor: usedTheme.BACKGROUND_COLOR, fontWeight: "bold" }}
                    data-tippy-content="Previous"
                >
                    <MdOutlineArrowBackIos />
                </Button>
                <p
                    style={{
                        color: usedTheme.JOB_LIST_COLOR,
                        fontSize: "14px",
                        fontWeight: "bold",
                        margin: "0px",
                        width: "fit-content",
                        paddingInline: "2px",
                    }}
                >
                    {currentRange}
                </p>
                {/* Next page Btn */}
                <Button
                    onClick={handleNextPage}
                    disabled={currentPage === pageCount}
                    style={{ padding: 0, width: "23px", height: "23px", alignItems: "center", display: "flex", justifyContent: "center", backgroundColor: usedTheme.BACKGROUND_COLOR, color: usedTheme.JOB_LIST_COLOR, borderColor: usedTheme.BACKGROUND_COLOR, fontWeight: "bold" }}
                    data-tippy-content="Next"
                    >
                    <MdOutlineArrowForwardIos />
                </Button>
            </div>
        </div>
    );
};

export default PaginationV2;